/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Esey Woldeabzghi
*/
import React, { useCallback } from 'react';
import AccessibleClick from '../../../accessible-click/AccessibleClick';
import Block from '../../../block/Block';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import useScrollIntoView from '../../../hooks/use-scroll-into-view';
import { focusElement } from '../../../../lib/focus/focus';
import styles from './SectionLink.less';

var SectionLink = function SectionLink(_ref) {
  var targetId = _ref.targetId,
      children = _ref.children;
  var scrollIntoView = useScrollIntoView();
  var handleClick = useCallback(function () {
    var targetEl = document.getElementById(targetId);

    if (targetEl) {
      scrollIntoView(targetEl);
      focusElement(targetEl);
    }
  }, [targetId, scrollIntoView]);
  return /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement(Block, {
    el: "a",
    className: getClasses({
      styles: styles,
      classes: ['container']
    }),
    onAccessibleClick: handleClick,
    tabIndex: 0,
    role: "link"
  }, children));
};

export default SectionLink;